<template>
  <div class="persona-field">
    <span class="role">Role</span>
    <div class="persona-input">
      <span class="persona-label">{{ personaLabel || 'Select role' }}</span>
      <v-btn
        variant="flat"
        size="small"
        color="bgDark"
        @click="() => setModal({ field: 'persona', value: true })"
      >
        Edit Selection
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { useAppAuthData } from '@/stores/app/authData';
import { useModals } from '@/stores/modals/modals';
import { computed } from 'vue';
import { personaOptions } from '@/components/settings/account/persona';

const { setModal } = useModals();

const personaLabel = computed(() => (personaOptions[useAppAuthData().authData.personaKey]));
</script>

<style lang="less" scoped>
.persona-field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 435px;

  .role {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    margin: 4px 0;
  }

  .persona-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 115px);
  }

  .persona-input {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border: 1px solid @stroke-dark;
    border-radius: 4px;
    font-weight: 300;
    color: @text-darkest;

    .v-btn {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      text-transform: none;
      padding: 4px;
      height: 24px;
    }
  }
}
</style>
